

































import Vue, { PropType } from 'vue';
import { get } from 'vuex-pathify';

import { Question } from '@/models/configurator/question';
import { ConfigurationAnswer } from '@/models/configurator/configuration';

export default Vue.extend({
  name: 'ConfigurationAnswerList',

  props: {
    configurationLoading: Boolean,
    configurationAnswers: Array as PropType<ConfigurationAnswer[]>
  },
  computed: {
    getQuestionById: get<(module: number, id: number) => Question>(
      'configuratorQuestion/getQuestionById'
    )
  }
});
